export default "__VITE_ASSET__KrI0c8$k__"